import React, { useState } from 'react';
import drinkwatrLogo from './images/drinkwatr.svg';
import Header from './header';
import SideSlide from './sideSlide';
import CountdownTimer from './countDownTimer';
import VideoSection from './videoSection';
import Footer from './footer';

function HomePage() {
  const [isSideSlideOpen, setIsSideSlideOpen] = useState(false);

  const handleMenuClick = () => {
    setIsSideSlideOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseSlide = () => {
    setIsSideSlideOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <main className="homeMain">
      <Header onMenuClick={handleMenuClick} />
      
      <SideSlide isOpen={isSideSlideOpen} onClose={handleCloseSlide} />

      <section className="centerContent">
        <div className="container">
          <div className="wtrLogoArea">
            <div className="watrLogo">
              <img src={drinkwatrLogo} className="img-fluid" alt="Drinkwatr" />
            </div>
            <div className="data">
              WE HAVE RE-POSITIONED TO{' '}
              <span>LEAD IN FRONTIER REUSABLE BOTTLE TECHNOLOGY.</span>
            </div>

            <CountdownTimer className="deskTime" />

            <div className="release">
              OUR RELEASE OF FRONTIER INNOVATION <br />IS{' '}
              <span>Coming SOON</span>
            </div>

            <CountdownTimer className="mobileTime" />
          </div>
        </div>
      </section>

      <VideoSection />
      <Footer />
    </main>
  );
}

export default HomePage;